import { makeStyles } from "@cirrus/ui-kit"

import { cx } from "ramda-extension/es"
import React from "react"
import T from "prop-types"

import Tip from "./tip.jsx"

import cv from "@cirrus/legacy/app-components/app/styles/colors/colors-default.less"

const useStyles = makeStyles({
  contentWrapper: {
    position: "relative",
    display: "inline-block",
    fontSize: "14px",
    paddingLeft: "7px",
    margin: "0",
    minHeight: "20px",
    lineHeight: "1rem",
    backgroundRepeat: "no-repeat",
    userSelect: "none",
    wordWrap: "break-word",
    wordBreak: "break-word",

    "&:hover": {
      "& $tip": { display: "block" },
    },
  },

  tip: {
    display: "none",
    position: "absolute",
    width: "max-content",
    maxWidth: "250px",
    top: "32px",
    left: "-6px",
    padding: "10px 10px",
    border: ["3px", "solid", cv.gray810],
    boxShadow: "2px 2px 4px 0px rgba(0,0,0,0.5)",
    marginTop: "5px",
    lineHeight: "20px",
    background: cv.gray810,
    color: cv.gray75,
    borderRadius: "6px",
    fontSize: "14px",
    zIndex: "5",

    "&:before": {
      content: '""',
      display: "inline-block",
      position: "absolute",
      borderLeft: ["3px", "solid", cv.gray810],
      borderTop: ["3px", "solid", cv.gray810],
      height: "12px",
      width: "12px",
      top: "-6px",
      transform: "rotate(45deg)",
      backgroundColor: cv.gray810,
    },
  },

  positionRight: {
    top: "0",
    left: "auto",
    right: "-10px",
    transform: "translateX(100%)",
    marginTop: "0",
    "&:before": { top: "5px", left: "-5px" },
  },

  field: {
    fontWeight: "bold",
  },
})

const TipContainer = ({ tipPosition, children, className, tipClassName, tipText, dataQa }) => {
  const classes = useStyles()

  const tipClass = cx(
    classes.tip,
    tipPosition === "right" ? classes.positionRight : null,
    tipClassName,
  )

  return (
    <div className={className}>
      <div className={classes.contentWrapper}>
        {children}
        {tipText && <Tip className={tipClass} tipText={tipText} />}
      </div>
    </div>
  )
}

TipContainer.propTypes = {
  tipPosition: T.string,
  className: T.string,
  tipClassName: T.string,
  children: T.node,
  tipText: T.string,
  dataQa: T.string,
}

export default TipContainer
